import { render } from "./VentaPOS.vue?vue&type=template&id=17700dbc&scoped=true"
import script from "./VentaPOS.vue?vue&type=script&lang=js"
export * from "./VentaPOS.vue?vue&type=script&lang=js"

import "./VentaPOS.vue?vue&type=style&index=0&id=17700dbc&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17700dbc"]])

export default __exports__